import { getTextSentimentColor } from '@modules/feedback/utils';
import { useIsFeedbackRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import { getFeedbackSentimentColor } from '@modules/feedbackV2/common/utils';
import { Stack } from '@mui/material';
import { SentimentName } from 'generated/graphql';
import capitalize from 'lodash/capitalize';

interface SentimentOptionProps {
  sentiment: SentimentName;
}

export const SentimentOption = ({ sentiment }: SentimentOptionProps) => {
  const isFeedbackRedesignEnabled = useIsFeedbackRedesignEnabled();

  return (
    <Stack direction="row" alignItems="center">
      <Stack
        borderRadius="50%"
        width={isFeedbackRedesignEnabled ? '8px' : '12px'}
        height={isFeedbackRedesignEnabled ? '8px' : '12px'}
        bgcolor={(theme) =>
          isFeedbackRedesignEnabled
            ? getFeedbackSentimentColor({ theme, sentiment })
            : getTextSentimentColor(sentiment) ?? undefined
        }
        mr={1}
      />
      {capitalize(sentiment)}
    </Stack>
  );
};
